module.exports = __webpack_public_path__ + "static/img/0546_1.446970e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_1.jpg
// module id = rPaQ
// module chunks = 1